<template>
  <div id="phone">
    <Agreement v-if="agree.show" @state="onAgreement($event)" />
    <div ref="container" class="container">
      <div class="input-wrapper">
        <h3 class="title">手机号</h3>
        <div class="input" :class="{ active: state.active === 'phone' }">
          <span>+86</span>
          <input
            v-model="phone"
            type="tel"
            ref="phoneInput"
            placeholder="您的手机号码"
            @focus="state.active = 'phone'"
            @blur="state.active = null"
          />
          <i
            v-if="phone.length"
            class="animated fadeIn clear-phone anyteachicon anyteach-gary"
            @click="clearPhone"
          />
        </div>
      </div>
      <div class="input-wrapper">
        <h3 class="title">验证码</h3>
        <div class="input" :class="{ active: state.active === 'smsCode' }">
          <input
            v-model="smsCode"
            type="tel"
            placeholder="4 位验证码"
            ref="smsInput"
            @focus="state.active = 'smsCode'"
            @blur="state.active = null"
          />
          <div class="get-code" v-if="sms.state == 0" @click="sendSms()">获取短信验证码</div>
          <div class="get-code countdown" v-if="sms.state === 1">{{ sms.countdown }} 秒</div>
        </div>
      </div>
      <Agree v-model="agree.checked" :size="agree.size">
        <p class="agree">
          <span class="text" @click="agree.checked = !agree.checked">我已阅读并同意</span>
          <span class="link" @click="agree.show = true">《AnyTeach 服务条款》</span>
        </p>
      </Agree>
      <div class="btn-primary login-button" @click="submit()">
        <span>更改手机号</span>
      </div>
    </div>
  </div>
</template>

<script>
import Agreement from "@/components/homelesson/post/Agreement"
import Agree from "mand-mobile/lib-vw/agree"

export default {
  name: "Phone",
  components: {
    Agree,
    Agreement,
  },
  data() {
    return {
      agree: {
        checked: true,
        size: "lg",
        show: false,
      },
      state: {
        active: null,
        timeouts: [],
      },
      isLoading: false,
      phone: "",
      sms: {
        code: "",
        state: 0,
        countdown: 60,
      },
      smsCode: "",
      numRegExp: new RegExp("^[0-9]*$"),
    }
  },
  watch: {
    phone: function (newVal, oldVal) {
      if (newVal.indexOf(" ") > 0 || newVal.length > 11 || !this.numRegExp.test(newVal)) {
        this.phone = oldVal
      }
      if (newVal.length === 11 && this.numRegExp.test(newVal)) {
        localStorage.setItem("phoneInput", newVal)
        this.$refs.smsInput.focus()
      }
    },
    smsCode: function (newVal, oldVal) {
      if (newVal.length > 4 || !this.numRegExp.test(newVal)) {
        this.smsCode = oldVal
      }
      if (
        newVal.length === 4 &&
        this.numRegExp.test(newVal) &&
        this.phone.length === 11 &&
        this.numRegExp.test(this.phone)
      ) {
        this.$refs.smsInput.blur()
        this.submit()
      }
    },
    isLoading: function (val) {
      if (val) {
        this.$toastLoading("更改中...")
      } else {
        this.$toastHide()
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  methods: {
    clearPhone() {
      this.phone = ""
    },
    onAgreement(state) {
      if (state) {
        this.agree.checked = state
      }
      this.agree.show = false
    },
    setSmsCountdown() {
      const timeout = (this.sms.countdown + 1) * 1000
      this.state.timeouts.push(
        setTimeout(() => {
          window.clearInterval(countdown)
          this.sms.countdown = timeout / 1000 - 1
          this.sms.state--
        }, timeout),
      )
      const countdown = window.setInterval(() => {
        this.sms.countdown--
      }, 1000)
    },
    async sendSms() {
      if (this.sms.state === 1) {
        return
      }
      if (this.phone.length < 11) {
        this.$refs.phoneInput.focus()
        return this.$toast("请输入 11 位手机号")
      }

      this.$toastLoading()

      try {
        const { code, msg } = await this.$api.auth.SMS_SEND({ phone: this.phone, phone_code: "86", use_type: 2 })
        if (code != 1000) {
          return this.$toastError(`${msg}（${code}）`)
        }
        this.setSmsCountdown()
        this.sms.state = 1
        this.smsCode = ""
        this.$refs.smsInput.focus()
        return this.$toastSuccess("已发送短信验证码")
      } catch (err) {
        this.$toastError("发送验证码失败，请稍后重试")
      }
    },
    async submit() {
      if (this.phone.length !== 11 || !/^[0-9]*$/.test(this.phone)) {
        this.$refs.phoneInput.focus()
        return this.$toast("请输入 11 位手机号")
      }
      if (this.smsCode.length !== 4 || !/^[0-9]*$/.test(this.smsCode)) {
        this.$refs.smsInput.focus()
        return this.$toast("请输入 4 位短信验证码")
      }

      if (!this.agree.checked) {
        return this.$toast("请先同意条款")
      }

      this.isLoading = true
      try {
        const { code, msg } = await this.$api.user.CHANGE_MOBILE({
          phone: this.phone,
          number: this.smsCode,
          phone_code: "86"
        })
        if (code === "1000") {
          return this.next()
        } else {
          return this.$toastError(`${msg}（${code}）`)
        }
      } catch (err) {
        this.isLoading = false
        this.$toastError("更改失败，请稍后重试")
        throw new Error(err)
      }
    },
    next() {
      this.$store.dispatch("user")
      this.$emit("complete")
    },
  },
  beforeDestroy() {
    this.state.timeouts.forEach(item => {
      window.clearTimeout(item)
    })
  },
}
</script>
<style lang="scss" scoped>
@import "../login/style.scss";

#phone {
  .container {
    max-width: 500px;
    margin: 0 auto;
  }
  .btn-primary,
  .btn-secondary {
    margin-top: 20px;
  }
  .btn-back {
    position: absolute;
    left: 0;
    bottom: 100px;
    text-align: center;
    width: 100%;
    transition: all 0.1s;
    &:active {
      opacity: 0.6;
    }
    .circle {
      background: $lightBlue;
      color: $blue;
      font-size: 20px;
      border-radius: 45px;
      width: 45px;
      height: 45px;
      display: flex;
      margin: 0 auto;
      align-items: center;
      justify-content: space-around;
    }
    span {
      margin: 5px auto 0 auto;
      line-height: 1.2;
      white-space: normal;
      color: $black;
      font-size: 0.8rem;
      @include avenir();
    }
  }

  @media only screen and (max-height: 600px) {
    .btn-back {
      position: relative;
      bottom: 0;
      margin-top: 5px;
      margin-bottom: 15px;
    }
  }
  .get-code {
    font-size: 0.8rem;
    color: $blue;
    width: 150px;
    @include avenir-demi();
    text-align: right;
    transition: all 0.1s;
    &:active {
      opacity: 0.6;
    }
  }
  .clear-phone {
    color: #bbb;
  }
  .countdown {
    color: $black;
    opacity: 0.6;
    @include avenir();
    font-weight: 400;
  }
  .coupon-container {
    h1 {
      text-align: center;
      font-size: 1rem;
      padding: 0 0 10px 0;
      @include avenir-demi();
    }
  }
  .agree {
    font-size: 0;
    span {
      font-size: 0.9rem;
    }
    .text {
      opacity: 0.6;
    }
    .link {
      @include avenir();
      font-weight: 500;
      border-bottom: 1px solid #dadada;
    }
  }
  @media only screen and (max-height: 480px) {
    .login-button {
      margin-top: 10px;
    }
    .input-wrapper {
      margin-bottom: 10px;
    }
    .md-agree {
      margin-top: -10px;
    }
  }
}
</style>
